import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { HtmlPageMetaContextProps } from '~/components/HtmlPageMeta/HtmlPageMetaContextProps'
import { HtmlPageMeta } from '~/components/HtmlPageMeta/HtmlPageMeta'
import { HtmlPageMetaResourceService } from '~/components/HtmlPageMeta/HtmlPageMetaResourceService'
import { Faq } from '~/components/Faq/Faq'
import styles from './index.module.scss'

interface ProfilePageProps {
  htmlPageMetaContextProps: HtmlPageMetaContextProps
}

export const FaqPage: NextPage<ProfilePageProps> = ({ htmlPageMetaContextProps }) => {
  const { t } = useTranslation('faq')

  const htmlPageMetaUrlProps = (
    new HtmlPageMetaResourceService(t('faq_page_title'), t('faq_page_description'))
  ).getProperties()
  const htmlPageMetaProps = { ...htmlPageMetaContextProps, ...htmlPageMetaUrlProps }

  return (
    <>
      <HtmlPageMeta { ...htmlPageMetaProps } />

      <section className={ styles.faq__container }>
        <Faq/>
      </section>
    </>
  )
}
